import React from 'react';
// @ts-ignore
import styles from './PatientsGroupsHistory.module.scss';
import PatientsGroupsHistoryList from './PatientsGroupsHistoryList';
import { useLazyGroupAuditLogsQuery } from '../../../../graphql/graphql';
import useFlatData from '../../../Base/Hooks/useFlatData';
import useGroupHistory from '../../Hooks/useGroupHistory';
import Loading from '../../../../Components/Loading';

interface Props {
	groupId: string;
	groupName: string;
}

const PatientsGroupsHistory: React.FC<Props> = ({ groupId, groupName }) => {
	const [getGroupHistoryQuery, { data, isLoading }] =
		useLazyGroupAuditLogsQuery();
	const { getGroupHistory, getNextPage, page, setPage } =
		useGroupHistory(getGroupHistoryQuery);
	const { flatData, hasMoreData, loadData, setFilter } = useFlatData(
		getGroupHistory,
		{
			data: data?.auditLogs?.data,
			totalPages: data?.auditLogs?.meta?.totalPages,
			page: data?.auditLogs?.meta?.page,
		},
		page,
		setPage,
		{
			targetEntityId: groupId,
			pagination: {
				take: 20,
			},
		},
	);

	if (!(flatData?.length && flatData?.length > 0)) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<PatientsGroupsHistoryList
				isLoading={isLoading}
				hasMoreData={hasMoreData}
				flatData={flatData}
				onLoadMore={getNextPage}
				onRefresh={loadData}
			/>
		</div>
	);
};

export default PatientsGroupsHistory;
